export default {
  ids: state => state.ids,
  adasInspection: state => state.adasInspection,
  adasmatrices: state => state.adasmatrices,
  links: state => state.links,
  lookups: state => state.lookups,
  repairlines: state => state.repairlines
}



// WEBPACK FOOTER //
// ./src/store/modules/adas/getters.js